import { render, staticRenderFns } from "./EditStaff.vue?vue&type=template&id=4ddc7bfe"
import script from "./EditStaff.vue?vue&type=script&lang=js"
export * from "./EditStaff.vue?vue&type=script&lang=js"
import style0 from "./EditStaff.vue?vue&type=style&index=0&id=4ddc7bfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports